import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { DtoComponent, createDtoProperties, mapCollection, AutocompleteDataSourceFn, MgAutocompleteData, Filter, stringFromFilterMethod, MgAutocompleteComponent } from '@mango/core';
import { Instrument } from 'src/app/core/dto/instrument';
import { InstrumentService } from 'src/app/core/service/instrument.service';
import { TypeCalculatie } from 'src/app/core/dto/type-calculatie';
import { TypeCalculatieService } from 'src/app/core/service/type-calculatie.service';
import { Relatie } from 'src/app/core/dto/relatie';
import { RelatieService } from 'src/app/core/service/relatie.service';
import { InstrumentDefinitie } from 'src/app/core/dto/instrument-definitie';
import { InstrumentDefinitieService } from 'src/app/core/service/instrument-definitie.service';
import { Rubriek } from 'src/app/core/dto/rubriek';
import { Personeel } from 'src/app/core/dto/personeel';
import { PersoneelService } from 'src/app/core/service/personeel.service';
import { Groep } from 'src/app/core/enums/groep';
import { Contactpersoon } from 'src/app/core/dto/contactpersoon';
import { ContactpersoonService } from 'src/app/core/service/contactpersoon.service';
import { listenerCount } from 'process';
import { Voorblad } from 'src/app/core/dto/voorblad';
import { Volgblad } from 'src/app/core/dto/volgblad';
import { VolgbladService } from 'src/app/core/service/volgblad.service';
import { VoorbladService } from 'src/app/core/service/voorblad.service';
import { setValue } from 'src/app/core/utils/form-helpers';
import { ProjectregelService } from 'src/app/core/service/projectregel.service';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '@mango/authentication';
import { UserService } from 'src/app/user/user.service';

@Component({
    selector: 'c-i-j-borculo-instrument',
    templateUrl: './instrument.component.html'/*,
    styleUrls: ['./instrument.component.css']*/
})
export class InstrumentComponent extends DtoComponent<Instrument> {
    properties = createDtoProperties<Instrument>([
        'oldID',
		{ 'relatie': ['naam1', 'postPlaats', 'verzendPlaats', 'oldID', 'centixId'] },
		{ 'instrumentDefinitie': [x => x.soortID.omschrijving, x => x.merkID.omschrijving,'type', x=> x.volgbladID.id, x => x.voorbladID.id] },
		{ 'personeel': ['naam'] },
		'groep',
		{ 'typeCalculatie': ['omschrijving'] },
		'naam',
		'afdeling',
		'eMail',
		'nr_Instrument',
		'nr_Fabriek',
		'nr_Barcode',
		'nr_Referentie',
		'lokatie',
		'soort',
		'merk',
		'type',
		'enbouwjaar',
		'entoelatingscode',
		'eNcode',
		'enunom',
		'eninom',
		'memo',
		'dKalibratie',
		'dOproep',
		'periode',
		{ 'voorbladID': ['omschrijving'] },
		{ 'volgbladID': ['omschrijving'] },
		'oproep',
		'isVervallen',
		'isWerkstandaard',
		'certificaat',
		'opmerking',
		'referentieMI',
		{ 'personeel_CrossID': ['naam'] },		
		{ 'bContact': ['naam'] },
		'isUsed',
		'dVerlopen',
		'centixId',
		'lastExportCentix',
		'lastExportCentixDoor',
		'reasonNotExported'
    ]);

	@ViewChild('personeelAutocomplete') personeelAutocomplete: MgAutocompleteComponent;
		
	getRelatieDataSource: AutocompleteDataSourceFn<Relatie>;
	getInstrumentDefinitieDataSource: AutocompleteDataSourceFn<InstrumentDefinitie>;
	getPersoneelDataSource: AutocompleteDataSourceFn<Personeel>;
	getPersoneelCrossDataSource: AutocompleteDataSourceFn<Personeel>;
	getTypeCalculatieDataSource: AutocompleteDataSourceFn<TypeCalculatie>;
	getContactpersoonDataSource: AutocompleteDataSourceFn<Contactpersoon>;
	getVoorbladIDDataSource: AutocompleteDataSourceFn<Voorblad>;
	getVolgbladIDDataSource: AutocompleteDataSourceFn<Volgblad>;

	RelatieFilter: Filter<Contactpersoon>;

	Groep = Groep;
	MeetInstrumenten: boolean = true;
	Energie: boolean = true;
		
    constructor(
        service: InstrumentService,
        injector: Injector,
		private instrumentService: InstrumentService,
		private relatieService: RelatieService,
		private instrumentDefinitieService: InstrumentDefinitieService,
		private personeelService: PersoneelService,
		private typeCalculatieService: TypeCalculatieService,
		private contactpersoonService: ContactpersoonService,
		private voorbladService: VoorbladService,
		private volgbladService: VolgbladService,
		private projectregelService: ProjectregelService,
		private userService: UserService, 
		private authService: AuthenticationService		

    ) { 
        super(injector, service, Instrument);
				
    }

    async ngOnInit() {

		var myUser = await this.userService.getById( +this.authService.currentUser.id, [x => x.meetInstrumenten, x => x.energie]).toPromise();
		this.MeetInstrumenten = myUser.meetInstrumenten;
		this.Energie = myUser.energie;

        super.ngOnInit();
        this._handleRoute();		
		this.setCustomActions();
    }

	private _handleRoute() {
		this.handleRoute("id", () => {
			this.getRelatieDataSource = MgAutocompleteData.complex<Relatie>(this.relatieService, null).text('naam1', 'postPlaats', 'verzendPlaats').number('oldID', 'centixId').datasource();
			this.getInstrumentDefinitieDataSource = MgAutocompleteData.complex<InstrumentDefinitie>(this.instrumentDefinitieService, null).text(x => x.soortID.omschrijving, 'type', x => x.merkID.omschrijving).include(x=> x.volgbladID.id, x => x.voorbladID.id).datasource();
			this.getPersoneelDataSource = MgAutocompleteData.of<Personeel>(this.personeelService, null, 'naam'); 
			this.getPersoneelCrossDataSource = MgAutocompleteData.of<Personeel>(this.personeelService, this.personeelService.getActiefFilter(), 'naam'); 
			this.getTypeCalculatieDataSource = MgAutocompleteData.of<TypeCalculatie>(this.typeCalculatieService, null, 'omschrijving');
			this.getVoorbladIDDataSource = MgAutocompleteData.of<Voorblad>(this.voorbladService, this.voorbladService.getActiefFilter(), 'omschrijving'); 
			this.getVolgbladIDDataSource = MgAutocompleteData.of<Volgblad>(this.volgbladService, this.volgbladService.getActiefFilter(), 'omschrijving'); 

			this.RelatieFilter = this.contactpersoonService.getRelatieFilter(this.item.relatie)
			this.getContactpersoonDataSource = MgAutocompleteData.of<Contactpersoon>(this.contactpersoonService, this.RelatieFilter, 'naam', 'eMail');
	
			if(this.isNewItem){
				if (this.Energie) {
					setValue('groep',Groep.Energie, this.form);
				}
				if (this.MeetInstrumenten){
					setValue('groep',Groep.MeetInstrument, this.form);
				}
			} else
			{
				// Relatie wissel niet op deze manier
				this.form.controls.relatie.disable();
			}
		});
	}

	setCustomActions() {
        
		// Attachments
		this.buildCustomActions(config => config.add({
			icon: "attach_file",
			name: "",
			fn: () => {
				let documentFolder = environment.DocumentFolder; 
				let bijlagenPath = environment.BijlagenFolder; 
				bijlagenPath = bijlagenPath + "\\instrument\\" + this.item.id;
				this.projectregelService.openDirectory(documentFolder + "\\" + bijlagenPath);
			},
			pin: true,
			show: () => !this.isNewItem && (navigator.userAgent == "Mi-Lab-Pro")
		}));

		// Wijzigen CentixId
		this.buildCustomActions(config => config.add({
			icon: "edit",
			name: "CentixId wijzigen",
			pin: false,
			fn: () => this.ChangeCentixId(), 
			show:this.authScheme.canDo("CIJBorculo.Logic.Requests.InstrumentOverruleCentixIdRequest") && this.authScheme.canUpdate("CIJBorculo.Logic.Instrument")         
		}));

		// Verversen Instrument
		this.buildCustomActions(config => config.add({
			icon: "refresh",
			name: "Verversen Instrument",
			fn: () => {
				this.form.invalid || !this.form.pristine ? this.dialogs.alert("Er is iets fout gegaan", "Er zitten nog fouten in het formulier, vul de onbrekende velden in en sla het formulier op.", "announcement") : this.instrumentService.verversenInstrument(this.item.id).toPromise().then(
					(value) => {
						if (value.successful) {
							this.dialogs.snackAction("Het instrument is ververst.", ()=>{},"ok", 3000);
							this.handleRoute("id");
						}
						else {
							this.dialogs.snackAction("Er is iets fout gegaan. Probeer het nogmaals!", ()=>{}, "ok", 3000);
						}
					});				
			},
			pin: false,
			show: () => !this.isNewItem && this.authScheme.canDo("CIJBorculo.Logic.VerversenInstrumentRequest")
		}));

		// Exporteren Centix
		this.buildCustomActions(config => config.add({
			icon: "outbound",
			name: "Exporteren Centix",
			fn: () => {
				this.dialogs.confirm("Bevestig Exporteren Centix", "Weet u zeker dat u de gegevens naar Centix wilt exporteren ?").then(
					(value) => {
						if (value) {
							this.instrumentService.exporterenCentix(this.item.id).toPromise().then(
								(value) => {
									if (value.successful) {
										this.dialogs.snackAction(value.message, ()=>{},"ok", 3000);
									} else {
										this.dialogs.snackAction("Export Centix niet gelukt! \n" + value.message, ()=>{},"ok", 5000);										
									}
									this.handleRoute("id");
								})
							}
						}
				);
			},
			pin: false,
			show: () => !this.isNewItem && this.item.relatie.centixId != null && this.authScheme.canDo("CIJBorculo.Logic.ExportInstrumentCentixRequest")
		}));

		// Back button
		this.buildCustomActions(config => config.add({
			icon: "arrow_back",
			name: "",
			fn: () => {
				this.location.back();
			},
			pin: true,
			show: () => !this.isNewItem
		}));
	}
	
	canDelete() {
		return false;
	}

	canRead(name: string){
		return this.authScheme.canRead(name);
	}
	
	getGroep(value) {

		switch (Number(value)) {
			case Groep.MeetInstrument:
				return "MI";
			case Groep.Energie:
				return "EN";
			case Groep.Beide:
				return "MI & EN";
			default:
				return value;
		}
	}

	onRelatieSelected(relatie: Relatie) {
		// empty all fields related to the relatie
		this.form.controls.bContact.setValue(null);
		this.form.controls.bContact.markAsDirty();

		if (relatie != null) {
			let myFilterProp = this.RelatieFilter.get('relatieID')[0];
			this.RelatieFilter.set(myFilterProp, relatie.id);
		}
	}

	onContactpersoonSelected(contactpersoon: Contactpersoon) {
		if (contactpersoon != null) {
			this.form.controls.eMail.setValue(contactpersoon.eMail);
			this.form.controls.eMail.markAsDirty();			
		}
	}
	
	relatieDisplayFn(relatie: Relatie) {
        return `${relatie.oldID} - ${relatie.naam1 } - ${relatie.postPlaats } - ${relatie.verzendPlaats }`;
	}

	contactpersoonDisplayFn(contactpersoon: Contactpersoon) {

		if (contactpersoon.eMail === undefined){
			return `${contactpersoon.naam }`;	
		} else {
	        return `${contactpersoon.naam } - ${contactpersoon.eMail } `;
		}
	}

	instrumentdefinitieDisplayFn(instrumentDefinitie: InstrumentDefinitie) {
        return `${(instrumentDefinitie.soortID != null ? instrumentDefinitie.soortID?.omschrijving : "") } - ${(instrumentDefinitie.merkID != null ? instrumentDefinitie.merkID?.omschrijving : "") } - ${(instrumentDefinitie.type != null ? instrumentDefinitie.type : "") }`;
	}

	async onInstrumentDefinitieSelected(instrumentDefinitie: InstrumentDefinitie) {
		// empty all fields related to the instrument
		if (instrumentDefinitie != null) {
			setValue("soort", (instrumentDefinitie.soortID != null ? instrumentDefinitie.soortID.omschrijving : null), this.form);
			setValue("type",  (instrumentDefinitie.type != null ? instrumentDefinitie.type : null), this.form);
			setValue("merk", (instrumentDefinitie.merkID != null ? instrumentDefinitie.merkID.omschrijving : null), this.form);
			
			if (instrumentDefinitie.voorbladID != null){
				const voorblad = await this.voorbladService.get({ properties: ["omschrijving"] , filter: this.voorbladService.getIdFilter(instrumentDefinitie.voorbladID.id)}).pipe(mapCollection<Voorblad>()).toPromise();
				setValue("voorbladID", voorblad[0], this.form);
			}

			if (instrumentDefinitie.volgbladID != null){
				const volgblad = await this.volgbladService.get({ properties: ["omschrijving"] , filter: this.volgbladService.getIdFilter(instrumentDefinitie.volgbladID.id)}).pipe(mapCollection<Volgblad>()).toPromise();
				setValue("volgbladID", volgblad[0], this.form);
			}			
		}
		else
		{
			setValue("soort", null, this.form);
			setValue("type", null, this.form);
			setValue("merk", null, this.form);
			setValue("voorbladID", null, this.form);
			setValue("volgbladID", null, this.form);
		}
	}

	ChangeCentixId() {
        
		this.dialogs.prompt("Wijzigen CentixId", "Wat is het (nieuwe) CentixId ? (0 = leegmaken)", {required:true}).then(
			(centixId) => {
				if (centixId != null && centixId.trim() != "")
				{
					this.instrumentService.ChangeCentixId(this.item.id, parseInt(centixId)).toPromise().then(
						(value) => {
							if (value.successful) {
								this.dialogs.snackAction("Het CentixId is bijgewerkt.", ()=>{} ,"ok", 3000);
								// Refresh/Reload
								this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
									this.router.navigateByUrl('/instrument/instrument/detail/' + this.item.id));
							}
							else {
								this.dialogs.snackAction("Er is iets fout gegaan. Het CentixId is niet bijgewerkt, probeer het nogmaals!", ()=>{},"ok", 3000);
							}
						});
				}
			});          
    }

	
}
